module.exports = __webpack_public_path__ + "2d1adc98c1f07ddd7980825b2797feab.pdf";